import { render, staticRenderFns } from "./PopUpTips.vue?vue&type=template&id=609854be&scoped=true&lang=pug"
import script from "./PopUpTips.vue?vue&type=script&lang=js"
export * from "./PopUpTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609854be",
  null
  
)

export default component.exports